import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class listaPrecioService {
    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}administracion/lista-precio`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarReplicas(id) {
        const response = await axios
            .get(`${ERP}administracion/lista-precio/listar-replicas/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async listarDetallePorIdListaPrecio(id) {
        const response = await axios
            .get(`${ERP}administracion/lista-precio/detalle-por-id-lista-precio/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarDetalleVentasPorTipoPrecioVenta(id) {
        const response = await axios
            .get(`${ERP}administracion/lista-precio/detalle-venta-tipo-precio-venta/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarDetalleLogisticaPorTipoPrecioVenta(id) {
        const response = await axios
            .get(`${ERP}administracion/lista-precio/detalle-logistica-tipo-precio-venta/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarDetalleLogisticaConversionPorTipoPrecioVenta(filter) {
        const response = await axios
            .get(`${ERP}administracion/lista-precio/detalle-logistica-conversion-tipo-precio-venta?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarDetalleLogisticaPorTipoImporteGanancia(id) {
        const response = await axios
            .get(`${ERP}administracion/lista-precio/detalle-logistica-tipo-importe-ganancia/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarDetalleLogisticaPorTipoMargenComercial(id) {
        const response = await axios
            .get(`${ERP}administracion/lista-precio/detalle-logistica-tipo-margen-comercial/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}administracion/lista-precio/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}administracion/lista-precio/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}administracion/lista-precio/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}administracion/lista-precio/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async formatoCargaMasiva(filter) {
        const response = await axios
            .get(`${ERP}administracion/lista-precio/formato-carga-masiva?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/
    async registrarCargaMasiva(data) {
        const response = await axios
            .put(`${ERP}administracion/lista-precio/registrar-carga-masiva`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async registrar(data) {
        const response = await axios
            .post(`${ERP}administracion/lista-precio`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}administracion/lista-precio`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async replicar(data) {
        const response = await axios
            .put(`${ERP}administracion/lista-precio/replicar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {

                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificarDetalle(data) {
        const response = await axios
            .put(`${ERP}administracion/lista-precio/detalle`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async eliminar(data) {
        const response = await axios
            .put(`${ERP}administracion/lista-precio/eliminar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async activar(data) {
        const response = await axios
            .put(`${ERP}administracion/lista-precio/activar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async subirCargaMasiva(file) {
        const formData = new FormData();
        formData.append('file', file);
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };

        const response = await axios
            .post(`${ERP}administracion/lista-precio/subir-carga-masiva`, formData, config)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async detalle_ExportarTipoMargenComercial(id) {
        const response = await axios
            .get(`${ERP}administracion/lista-precio/detalle-exportar-margen-comercial/${id}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async detalle_ExportarTipoImporteGanancia(id) {
        const response = await axios
            .get(`${ERP}administracion/lista-precio/detalle-exportar-importe-ganancia/${id}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async detalle_ExportarTipoPrecioVenta(id) {
        const response = await axios
            .get(`${ERP}administracion/lista-precio/detalle-exportar-precio-venta/${id}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new listaPrecioService();